import { useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import { AnimatePresence } from "framer-motion";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Ribbon } from "@/components/site/Marquee";
import { Details } from "@/components/site/Details";
import { Countdown } from "@/components/site/Countdown";
import { Gallery } from "@/components/site/Gallery";
import { Location } from "@/components/site/Location";
import { Rsvp } from "@/components/site/Rsvp";
import { Footer } from "@/components/site/Footer";
import { IntroCurtain } from "@/components/site/IntroCurtain";
import { MusicToggle } from "@/components/site/MusicToggle";

let lenisSingleton = null;

function App() {
  const [introState, setIntroState] = useState("closed"); // closed | opening | done
  const [playing, setPlaying] = useState(false);
  const audioRef = useRef(null);
  const enteredRef = useRef(false);

  useEffect(() => {
    if (!lenisSingleton) {
      lenisSingleton = new Lenis({ autoRaf: true });
      window.__lenis = lenisSingleton;
    }
    // Best-effort autoplay (most browsers block until interaction)
    if (audioRef.current) {
      audioRef.current.volume = 0.385;
      audioRef.current.play().then(() => setPlaying(true)).catch(() => {});
    }
  }, []);

  // Drive the curtain "done" state after the opening animation completes
  useEffect(() => {
    if (introState !== "opening") return undefined;
    const id = window.setTimeout(() => setIntroState("done"), 1650);
    return () => window.clearTimeout(id);
  }, [introState]);

  const handleEnter = () => {
    if (enteredRef.current) return;
    enteredRef.current = true;
    const a = audioRef.current;
    if (a) {
      a.volume = 0.385;
      a.play().then(() => setPlaying(true)).catch(() => setPlaying(false));
    }
    setIntroState("opening");
  };

  const toggleMusic = () => {
    const a = audioRef.current;
    if (!a) return;
    if (a.paused) {
      a.play().then(() => setPlaying(true)).catch(() => {});
    } else {
      a.pause();
      setPlaying(false);
    }
  };

  return (
    <div className="App relative bg-ink">
      <audio ref={audioRef} src="/wedding-song.mp3" loop preload="auto" />

      <AnimatePresence>
        {introState !== "done" && (
          <IntroCurtain opening={introState === "opening"} onEnter={handleEnter} />
        )}
      </AnimatePresence>

      <div className="noise-overlay" />
      <div className="vignette" />
      <Nav />
      <main>
        <Hero />
        <Ribbon />
        <Details />
        <Countdown />
        <Gallery />
        <Location />
        <Rsvp />
      </main>
      <Footer />

      <MusicToggle playing={playing} onToggle={toggleMusic} />
      <Toaster position="bottom-center" />
    </div>
  );
}

export default App;
